module.exports = __webpack_public_path__ + "img/双边床头.fe5cd6f0.webp";